/**
 * Shared interior-page hero — unified navy/gold across all pages.
 */
export default function PageHero({ tag, title, lede }) {
  return (
    <>
      <header className="page-hero">
        <span className="page-tag">{tag}</span>
        <h1>{title}</h1>
        {lede && <p className="lede">{lede}</p>}
      </header>
      <div className="gold-rule" />
    </>
  );
}
